namespace GeniuzPOS.Inventory {
    export interface IcStkAdjCodeForm {
        StkAdjType: Serenity.RadioButtonEditor;
        StkAdjCode: Serenity.StringEditor;
        StkAdjDesc: Serenity.StringEditor;
    }

    export class IcStkAdjCodeForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStkAdjCode';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStkAdjCodeForm.init)  {
                IcStkAdjCodeForm.init = true;

                var s = Serenity;
                var w0 = s.RadioButtonEditor;
                var w1 = s.StringEditor;

                Q.initFormType(IcStkAdjCodeForm, [
                    'StkAdjType', w0,
                    'StkAdjCode', w1,
                    'StkAdjDesc', w1
                ]);
            }
        }
    }
}
